import React, { useState } from "react";
import ProgressBar from "@ramonak/react-progress-bar";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import {  UpdateClientProfileSchema } from "../../validationSchema/authSchema";
import StepFirst from "../resource/contactdetail";
import StepSecond from "../resource/servicedetail";
import StepThird from "../resource/projectdetail";
import Submit from "../resource/submit";

const ResourcerPopup = () => {
  const [step, setStep] = useState(1);
  const [progress, setProgress] = useState(25);
  const [check, setCheck] = useState(false);
  const [skill,setSkill]=useState([])

  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm({
    defaultValues: {
      role: "",
    },
    resolver: yupResolver(UpdateClientProfileSchema),
  });

  const handleSignup = async (values) => {
    console.log('Hello ---->',values,errors);
    if(Object.keys(errors).length !== 0) return
    console.log('===>>>>>>')
    handleStepChange(1, 25)

    // const res = await signup(values);
    // if (res.code !== 401) {
    //   setIsRegister(true);
    //   setTimeout(() => {
    //     setIsRegister(false);
    //     window.location.href = "/";
    //   }, 2000);
    // }
  };

  // const checkInputBlank = (dataObj) =>{
  //   let isValid = true;
  //   for( let keyValue in dataObj){
  //     if(!dataObj[keyValue] &&  isValid) isValid = false 
  //   }
  // }

  const handleStepChange = (val, prog) => {
    console.log({val, prog,step})
    if (val === -1 && step === 1) return;
    setStep(step + val);
    setProgress(progress + prog);
    getResourceStep(step + val);
  };

  const handleChange = (vl) => {
    if (vl.length > 0) {
      setCheck(false);
    } else {
      setCheck(true);
    }
  };

  const getResourceStep = (stepComing) => {
    switch (stepComing) {
      case 1:
        return (
          <StepFirst
            handleStepChange={handleStepChange}
            handleSubmit={handleSubmit}
            handleSignup={handleSignup}
            register={register}
            errors={errors}
            handleChange={handleChange}
            check={check}
          />
        );
      case 2:
        return <StepSecond handleStepChange={handleStepChange} setSkill={setSkill} skill={skill}/>;
      case 3:
        return <StepThird handleStepChange={handleStepChange} />;
      case 4:
        return <Submit handleStepChange={handleStepChange} />;
      default:
        return "";
    }
  };

  return (
    <div className='resource-popup-content'>
      <div className='resource-progressbar'>
        <ProgressBar
          completed={progress}
          bgColor='#ff990a'
          borderRadius='12px 12px 0 0'
          baseBgColor='#E0E0E0'
          labelColor='#000'
          maxCompleted={100}
        />
      </div>
      <div className='resource-popup-body'>{getResourceStep(step)}</div>
    </div>
  );
};

export default ResourcerPopup;
